<div class="product-card-row">
  <div class="row justify-content-center">
    <div class="col-lg-8">
      <h2 class="product-card-row__title h1-md" *scText="title()"></h2>
      @if (content()?.value) {
        <div class="product-card-row__content" *scText="content()!"></div>
      }
    </div>
  </div>
  <div class="card-grid" [attr.data-cards]="cards().length">
    @for (card of cards(); track $index) {
      <wl-product-card
        [title]="card.title"
        [content]="card.content"
        [image]="card.image"
        [button1]="card.button1"
        [button2]="card.button2"
        [details]="card.details"
        [cost]="card.cost"
        [costAddition]="card.costAddition"
      />
    }
  </div>
</div>
